import aimmaBedsidePreview from "../../../image/health/aimma-bedside-preview.png";
import aimmaKioskPreview from "../../../image/health/aimma-kiosk-preview.png";
import aimmaNotesPreview from "../../../image/health/aimma-nurse/aimma-notes-preview.png";
import nurseBedsideTablet from "../../../image/health/aimma-nurse/nurse-bedside-tablet.png";
import zoeyHospital from "../../../image/health/zoey-hospital.png";
import { isAimmaProductId } from "../healthTypes";

export const healthAimmaNursePreviewAssets: Record<string, string> = {
    "aimma-kiosk": aimmaKioskPreview,
    "aimma-bedside": aimmaBedsidePreview,
    "aimma-notes": aimmaNotesPreview,
    "nursing-kiosk-hero": aimmaKioskPreview,
    "ui-kiosk-digital-human": aimmaKioskPreview,
    "ui-bedside-tablet": aimmaBedsidePreview,
    "ui-nurse-bedside-tablet": nurseBedsideTablet,
    "ui-nursing-coordination-queue": zoeyHospital,
    "ui-nursing-notes-mic": aimmaNotesPreview,
};

export function getAimmaNurseModulePreviewSrc(productId: string | undefined): string {
    if (productId && healthAimmaNursePreviewAssets[productId]) {
        return healthAimmaNursePreviewAssets[productId];
    }
    if (productId === "aimma-kiosk") {
        return aimmaKioskPreview;
    }
    if (productId === "aimma-bedside") {
        return aimmaBedsidePreview;
    }
    if (productId === "aimma-notes") {
        return aimmaNotesPreview;
    }
    if (productId && isAimmaProductId(productId)) {
        return zoeyHospital;
    }
    return zoeyHospital;
}

export function getAimmaNurseVisualPreviewSrc(assetKey: string | undefined): string | undefined {
    if (!assetKey) return undefined;
    return healthAimmaNursePreviewAssets[assetKey];
}
